import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})


/*
01/09/2025 - Kauan
classe que salva os charts depois de serem processados (process-xxxxxx-chart) no localstorage
*/
export class ExportChartImage {
  save(chart: string): void {
    const canvas = document.getElementById(chart) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    const composition = ctx.globalCompositeOperation;

    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.restore();

    if (chart === 'myChart0'){
      localStorage.setItem('pie', canvas.toDataURL('image/png', 1));
    }
    if (chart === 'myChart1'){
      localStorage.setItem('bar', canvas.toDataURL('image/png', 1));
    }
    if (chart === 'myChart2'){
      localStorage.setItem('cons', canvas.toDataURL('image/png', 1));
    }

    ctx.globalCompositeOperation = composition;
  }
}
